import React from "react";
import PaymentForm from "./components/paymentForm/PaymentForm";
import PaymentInfo from "./components/paymentInfo/paymentInfo";
import PaymentMerchantInfo from "./components/paymentMerchantInfo/paymentMerchantInfo";
import { useIdleTimer } from "./utils/lastActivityHook";
import { getPaymentDetails } from "./components/redux/main-reducer";
import PaymentCheque from "./components/paymntCheque/paymentCheque";
import { useSelector } from "react-redux";

function App() {
  const paymentDetails = useSelector(getPaymentDetails);
  const searchParams = new URLSearchParams(window.location.search);
  const isPaymentPage = searchParams.get("page") === "1";
  const isInvType = searchParams.get("inv_type") === "4";

  useIdleTimer(isInvType);

  return (
    <div>
      {isPaymentPage ? (
        <PaymentForm />
      ) : paymentDetails?.is_finished ? (
        <PaymentCheque />
      ) : isInvType ? (
        <PaymentMerchantInfo />
      ) : (
        <PaymentInfo />
      )}
    </div>
  );
}

export default App;
